import React from 'react';
import ImageHolder from '../../ImageHolder';
import getImageUrl from '../../../utils/getImageUrl'

const ImageFeedView = ({ images, postPath }) => {

  // 투명 이미지
  const IMG_BOX = "data:image/png;base64,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";

  const firstImage = images.first();
  const isSquare = firstImage.width === firstImage.height;
  const isHorizontal = firstImage.width > firstImage.height;

  if (images.size === 1) {
    return (
      <div className="post_card">
        <div className="card_default">
          <div className="wrap_thumb">
            <a href={postPath} className="link_post">
              <ImageHolder image={firstImage}/>
            </a>
          </div>
        </div>
      </div>
    );
  } else if (images.size === 2) {

    const viewStyle = () => {
      if (isSquare) {
        return 'card_box2_rect';
      } else if (!isHorizontal) {
        return 'card_vertical';
      }
      return '';
    };
    return (
      <div className="post_card card_box card_box2">
        <div className={`card_default ${viewStyle()}`}>
          <img src={IMG_BOX} className="thumb_box" alt="" />
            <ul className="list_thumb">
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(0).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                  </div>
                </a>
              </li>
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(1).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                  </div>
                </a>
              </li>
            </ul>
        </div>
      </div>
    );

  } else if (images.size === 3) {
    const viewStyle = () => {
      if (isSquare) {
        return 'card_box3_rect';
      } else if (!isHorizontal) {
        return 'card_vertical';
      }
      return '';
    };
    return (
      <div className="post_card card_box card_box3">
        <div className={`card_default ${viewStyle()}`}>
          <img src={IMG_BOX} className="thumb_box" alt="" />
            <ul className="list_thumb">
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(0).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                  </div>
                </a>
              </li>
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(1).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                  </div>
                </a>
              </li>
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(2).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                  </div>
                </a>
              </li>
            </ul>
        </div>
      </div>
    );
  } else {
    const viewStyle = () => {
      if (isSquare) {
        return 'card_square';
      } else if (!isHorizontal) {
        return 'card_vertical';
      }
      return '';
    };
    return (
      <div className="post_card card_box card_box4">
        <div className={`card_default ${viewStyle()}`}>
          <img src={IMG_BOX} className="thumb_box" alt="" />
            <ul className="list_thumb">
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(0).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                  </div>
                </a>
              </li>
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(1).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                  </div>
                </a>
              </li>
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(2).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                  </div>
                </a>
              </li>
              <li>
                <a href={postPath} className="link_thumb">
                  <div className="wrap_thumb" style={{ backgroundImage: `url(\"${getImageUrl(images.get(3).largeUrl)}\")` }}>
                    <span className="screen_out">이미지 보기</span>
                    <span className="frame_g" />
                    {
                      images.size > 4 && <span className="txt_all">{`+${images.size - 4}`}<span className="screen_out">개 더보기</span></span>
                    }
                  </div>
                </a>
              </li>
            </ul>
        </div>
      </div>
    );
  }
};

export default ImageFeedView;


// WEBPACK FOOTER //
// ./src/components/PostBox/FeedView/ImageFeedView.js